import { PasswordValidation } from '@shared/models/password-complexity.enum';

export const PasswordValidator = {
  messages: {
    PASS_TOO_SHORT: '8 characters minimum',
    PASS_NO_LOWERCASE_CHARACTER: 'One lowercase character',
    PASS_NO_UPPERCASE_CHARACTER: 'One uppercase character',
    PASS_NO_NUMERIC_CHARACTER: 'One number',
    PASS_NO_SPECIAL_CHARACTER: 'One special (symbol) character',
  } as Record<PasswordValidation, string>,
  validate(value: string): PasswordValidation[] {
    const MINIMUM_PASSWORD_LENGTH = 8;
    const LOWERCASE_PATTERN = /^(?=.*[a-z]).+$/;
    const UPPERCASE_PATTERN = /^(?=.*[A-Z]).+$/;
    const SPECIAL_CHARACTER_PATTERN = /([-+=_!@#$%^&*.,;:'"<>/?`~[\](){}\\|\s])/;
    const NUMERIC_CHARACTER_PATTERN = /^(?=.*[0-9]).+$/;

    const validations: PasswordValidation[] = [];

    if (value.length < MINIMUM_PASSWORD_LENGTH) {
      validations.push('PASS_TOO_SHORT');
    }
    if (!value.match(LOWERCASE_PATTERN)) {
      validations.push('PASS_NO_LOWERCASE_CHARACTER');
    }
    if (!value.match(UPPERCASE_PATTERN)) {
      validations.push('PASS_NO_UPPERCASE_CHARACTER');
    }
    if (!value.match(NUMERIC_CHARACTER_PATTERN)) {
      validations.push('PASS_NO_NUMERIC_CHARACTER');
    }
    if (!value.match(SPECIAL_CHARACTER_PATTERN)) {
      validations.push('PASS_NO_SPECIAL_CHARACTER');
    }

    return validations;
  },
  validateWithMessages(value: string): string[] {
    const validations = this.validate(value);
    return validations.map(validation => this.messages[validation]);
  },
} as const;
